import React from 'react';

// eslint-disable-next-line
export const deeplyTraverseChildren = (children, callback) => {
  React.Children.forEach(children, child => {
    callback(child);
    if (child.props?.children) {
      deeplyTraverseChildren(child.props.children, callback);
    }
  });
};

export const updateSelectAllOption = (children, setAllOptions) => {
  setAllOptions([]);
  deeplyTraverseChildren(children, child => {
    if (child.props.value !== undefined) {
      setAllOptions(actualAllOptions => [
        ...actualAllOptions,
        {
          value: child.props.value,
          label: child.props.label,
        },
      ]);
    } else if (typeof child.props.children === 'function' && child.props.contextData?.length > 0) {
      setAllOptions(actualAllOptions => [
        ...actualAllOptions,
        ...child.props.contextData.map(({ value, label }) => ({ value, label }))
      ]);
    }
  });
};
